import Resource from "./resource";

export class SpaceRootResource extends Resource {}
